import React, { useState } from 'react';
import Popup from 'reactjs-popup';
import AhoyMessageShow from '../../Marketing/AhoyMessages/AhoyMessageShow';

const badgeClass = (status) => {
  if (['failed', 'bounced', 'suppressed'].includes(status)) return 'op-badge op-badge-failed';
  return 'op-badge op-badge-paid';
};

const OrderEmailsCard = ({ emails, team, csrfToken }) => {
  const [preview, setPreview] = useState(null);

  return (
    <div className="op-card">
      <h2 className="op-section-title">Emails</h2>
      {!emails || emails.length === 0 ? (
        <div className="op-muted">No emails have been sent for this order yet.</div>
      ) : (
        <table className="op-table">
          <thead>
            <tr><th>Subject</th><th>Time</th><th>Status</th></tr>
          </thead>
          <tbody>
            {emails.map((message) => (
              <tr key={message.id}>
                <td data-label="Subject">
                  <a href="#" className="op-link" onClick={(e) => { e.preventDefault(); setPreview(message); }}>
                    {message.subject}
                  </a>
                </td>
                <td data-label="Time">{message.relevant_timestamp}</td>
                <td data-label="Status"><span className={badgeClass(message.status)}>{message.status}</span></td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      <Popup open={preview != null} onClose={() => setPreview(null)} closeOnDocumentClick modal className="popup-modal">
        {preview && (
          <div>
            <div className="d-flex justify-content-between align-items-center px-3 pt-3">
              <strong style={{ fontSize: '18px' }}>Email Preview</strong>
              <a href="#" className="op-link" onClick={(e) => { e.preventDefault(); setPreview(null); }}>
                <i className="fa fa-times"></i>
              </a>
            </div>
            <div className="p-3">
              <AhoyMessageShow csrfToken={csrfToken} team={team} ahoyMessage={preview} />
            </div>
          </div>
        )}
      </Popup>
    </div>
  );
};

export default OrderEmailsCard;
